import { CSSProperties } from 'react';

import { bodyWidth } from 'constants/values';

export const container: CSSProperties = {
  backgroundColor: '#fff',
  width: '100%',
};

export const body: CSSProperties = {
  height: 622,
  margin: 'auto',
  position: 'relative',
  width: bodyWidth,
};

export const image1: CSSProperties = {
  height: 216,
  left: 260,
  position: 'absolute',
  top: 176,
  width: 792,
};

export const image2: CSSProperties = {
  height: 553,
  left: 937,
  position: 'absolute',
  top: 15,
  width: 403,
};

export const image3: CSSProperties = {
  height: 60,
  left: 864,
  position: 'absolute',
  top: 474,
  width: 81,
};
